export enum UserEmailRequestStatusAjax {
  CANCELED = 'canceled',
  PENDING = 'pending',
  VERIFIED = 'verified',
}

export interface UserEmailRequestAjax {
  readonly id: number;
  readonly email: string;
  readonly ip_address: string;
  readonly status: UserEmailRequestStatusAjax;
}

export interface UserEmailRequestGetResultAjax {
  readonly email_requests: readonly UserEmailRequestAjax[];
  readonly allow_passwordless_change: boolean;
}

export type UserEmailRequestPostResultAjax = UserEmailRequestAjax;

export interface UserEmailPostRawPayload {
  readonly email: string;
  readonly password: string;
}

export interface UserEmailRequestDeleteResultAjax {
  readonly id: number;
}

export interface UserEmailDeleteRawPayload {
  readonly email_request_id: number;
}
